function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { flexRender } from '@tanstack/react-table';
import { Translate } from "../../../../I18N";


const dndHoverClass = 'shadow-[inset_0_-4px_#3949AB]';
const childIndicatorClass = 'shadow-[inset_5px_0px_0px_-1px_#3949AB]';

const inactiveGradientStyle = {
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%,-50%)',
  width: '16px',
  height: '80%',
  background: 'radial-gradient(circle, #c5cae9 25%, transparent 26%) 0% 0% / 8px 10px'
};

const activeGradientStyle = _objectSpread(_objectSpread({},
inactiveGradientStyle), {}, {
  background: 'radial-gradient(circle, #303f9f 25%, transparent 26%) 0% 0% / 8px 10px' });


const getSytles = (expanded, isOver) => {
  const expandedGroupStyles = expanded ?
  'bg-indigo-100 border-indigo-100 hover:bg-indigo-200 hover:border-indigo-200' :
  '';
  const dndHoverStyles = isOver ? dndHoverClass : '';
  return `${expandedGroupStyles} ${dndHoverStyles}`;
};

const RowDragHandleCell = ({ row }) => {
  const { attributes, listeners, isDragging } = useSortable({
    id: row.id
  });
  const [handlerStyle, setHandlerStyle] = useState(inactiveGradientStyle);

  const canExpand = row.originalSubRows;
  const expanded = row.getIsExpanded();

  useEffect(() => {
    if (canExpand && expanded && isDragging) {
      row.toggleExpanded();
    }
  }, [isDragging]);

  return (/*#__PURE__*/
    React.createElement("button", _extends({},
    attributes,
    listeners, {
      onMouseEnter: () => {
        setHandlerStyle(activeGradientStyle);
      },
      onMouseLeave: () => {
        setHandlerStyle(inactiveGradientStyle);
      },
      type: "button",
      style: isDragging ? activeGradientStyle : handlerStyle }), /*#__PURE__*/

    _jsx("span", { className: "sr-only" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Drag row")
    )
    ));

};

const DraggableRow = ({
  row,
  colSpan,
  groupColumnIndex,
  dndEnabled





}) => {var _row$originalSubRows;
  const expanded = row.getIsExpanded();
  const isEmpty = ((_row$originalSubRows = row.originalSubRows) === null || _row$originalSubRows === void 0 ? void 0 : _row$originalSubRows.length) === 0;
  const isChild = row.depth > 0;

  const { transform, setNodeRef, isDragging, isOver } = useSortable({
    id: row.id
  });

  const { setNodeRef: dropNoderef, isOver: isOverDropzone } = useSortable({
    id: `${row.id}-dropzone`
  });

  const draggingStyles = {
    transformOrigin: 'left',
    transform: CSS.Transform.toString({
      x: 0,
      y: (transform === null || transform === void 0 ? void 0 : transform.y) || 0,
      scaleX: 0.7,
      scaleY: 0.7
    }),
    cursor: 'grabbing',
    zIndex: 1,
    position: 'relative',
    opacity: 0.9,
    outline: 'rgb(81 69 205) solid 4px',
    backgroundColor: 'white'
  };

  const rowStyles = getSytles(expanded, isOver);

  return (/*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    React.createElement("tr", {
      style: isDragging ? draggingStyles : undefined,
      ref: setNodeRef,
      className: `text-gray-900 border-b transition-colors hover:bg-gray-50 ${rowStyles}` },

    row.getVisibleCells().map((cell, index) => {var _cell$column$columnDe;return (/*#__PURE__*/
        _jsx("td", {

          className: `relative px-4 py-2 ${(_cell$column$columnDe = cell.column.columnDef.meta) === null || _cell$column$columnDe === void 0 ? void 0 : _cell$column$columnDe.contentClassName} ${isChild && groupColumnIndex === index ? childIndicatorClass : ''}` }, cell.id,

        flexRender(cell.column.columnDef.cell, cell.getContext())
        ));}
    )
    ),

    isEmpty && expanded && /*#__PURE__*/
    React.createElement("tr", {
      ref: dropNoderef,
      className: `border-b text-gray-900 transition-colors ${isOverDropzone ? dndHoverClass : ''}` }, /*#__PURE__*/

    _jsx("td", { className: "px-4 py-3 text-sm italic text-gray-600", colSpan: colSpan }, void 0,
    dndEnabled ? /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Empty group. Drop here to add") : /*#__PURE__*/

    _jsx(Translate, {}, void 0, "This group is empty")

    )
    )

    ));

};

const DnDHeader = () => /*#__PURE__*/_jsx(Translate, { className: "sr-only" }, void 0, "Empty");

export { RowDragHandleCell, DraggableRow, DnDHeader };